import { Injectable } from '@angular/core';
import { RmsService } from "../../../../projects/jv-common/src/public_api";
import {CanActivate, Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class GuardService implements CanActivate {

  constructor(private rms: RmsService) {
  }

  canActivate(): boolean {
    if(!this.rms.isLoggedIn){
        this.rms.loggedOut.emit();
        return false;
    }
    return true;
  }
}
